import useListService from '@/data/hook/useListService';
import { REQUEST_STALE_TIME_IN_MS as staleTime } from '@/constants';
import ActivityTable from '@/components/activity/ActivityTable';
import User from '@/models/User';
import { SmartTableClassNames } from '@/components/ui/daisy/templates/smart-table/types';
import { activityProgressQueries } from '@/data/query-keys/activityProgressQueryKey';
import useActivityPendenciesFilter from '@/data/hook/useActivityPendenciesFilter';

type ActivitiesDashboardTabProps = {
  user: User;
  tableClassNames: SmartTableClassNames;
  tableClassName: string;
  emptyMessage?: string;
  pageSize?: number;
};

export function ActivitiesDashboardTab({
  user,
  tableClassNames,
  tableClassName,
  emptyMessage,
  pageSize,
}: ActivitiesDashboardTabProps) {
  const activityFilter = useActivityPendenciesFilter();

  const activityQuery = activityProgressQueries.list({
    ...activityFilter.filters,
    pageSize: pageSize ?? 6,
  });

  const {
    results: pendingActivities,
    isInitialLoading: isLoadingActivities,
    error: activitiesError,
  } = useListService({
    queryKey: activityQuery.queryKey,
    queryFn: activityQuery.queryFn,
    enabled: !!user,
    keepPreviousData: true,
    staleTime,
  });

  return (
    <ActivityTable
      ordering={activityFilter.filters.ordering}
      onToggleOrdering={activityFilter.toggleOrdering}
      data={pendingActivities}
      isLoading={isLoadingActivities}
      error={activitiesError}
      emptyMessage={emptyMessage}
      classNames={tableClassNames}
      className={tableClassName}
    />
  );
}
